import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TerminationConditionsPopupComponent } from "@app/views/contact-us/termination-conditions-popup/termination-conditions-popup.component";
import { TranslateModule } from "@ngx-translate/core";
import { RequestNatureOptions } from "@shared/enums/request-nature-options";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-termination-section",
  standalone: true,
  imports: [DropdownModule, TranslateModule, CommonModule, ReactiveFormsModule, TerminationConditionsPopupComponent],
  templateUrl: "./termination-section.component.html",
})
export class TerminationSectionComponent {
  /**
   * Indicates the current request nature.
   */
  @Input() requestNature!: string | null;

  /**
   * Options for the termination reasons dropdown.
   */
  @Input() reasonOptions!: any[]; // Replace 'any' with your specific type

  /**
   * The parent form group.
   */
  @Input() form!: FormGroup;

  /**
   * Emits an event when the termination conditions popup is closed.
   */
  @Output() terminationReasonSelected = new EventEmitter<void>();

  /**
   * Controls the visibility of the termination conditions popup.
   */
  displayTerminationConditionsPopup = false;
  RequestNatureOptions = RequestNatureOptions;

  /**
   * Opens the termination conditions popup.
   */
  showTerminationConditionsPopup() {
    this.displayTerminationConditionsPopup = true;
  }

  /**
   * Handles the closing of the termination conditions popup.
   */
  onCloseTerminationConditionsPopup() {
    this.displayTerminationConditionsPopup = false;
  }

  /**
   * Handles changes in the termination reason dropdown.
   */
  onSelectTerminationReason() {
    this.terminationReasonSelected.emit();
  }
}
